import { Box, Button, Card, CardActions, CardHeader, Popover, TextField } from "@mui/material"
import { ChangeEvent, useContext, useState } from "react";
import { connect } from "react-redux";
import { selectProject, selectUserId } from "../../redux/selectors/editor";
import { CommentType } from "./CommentContainer";
import { FirebaseContext } from "../firebase/FirebaseProvider";
import { selectUser } from "../../redux/selectors/firebase";
import UserAvatar from "../navbar/UserAvatar";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
    commentCard: {
        maxWidth: 320
    },
    container: {
        display: 'flex',
        gridGap: "4px",
        flexWrap: "wrap",
        marginTop: theme.spacing(1)
    }
}));

interface Props
{
    target: HTMLElement | null
    project: string
    getSelectionDetails: () => CommentType
    user: { name: string },
    userId: string,
    onClose: () => void
}

function AddCommentCard({ target, userId, user, getSelectionDetails, project, onClose }: Props)
{
    const classes = useStyles();
    const [comment, setComment] = useState("");
    const { pushComment } = useContext(FirebaseContext);
    const handleClickAddComment = () =>
    {
        pushComment(project, {
            userId: userId,
            timestamp: Date.now(),
            comment,
            type: getSelectionDetails()
        });
        close();
    }

    const handleCommentChange = (event: ChangeEvent<HTMLInputElement>) => 
    {
        setComment(event.currentTarget.value);
    }

    const close = () =>
    {
        setComment("");
        onClose();
    }

    const open = Boolean(target);
    const id = open ? 'add-comment-popover' : undefined;

    return <Popover
        id={id}
        open={open}
        anchorEl={target}
        onClose={onClose}
        anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
        }}>
        <Box>
            <Card className={classes.commentCard}>
                <CardHeader avatar={<UserAvatar />} title={user.name} />
                <CardActions disableSpacing>
                    <Box className={classes.container}>
                        <TextField id="comment" variant={"outlined"} size={"small"} placeholder={"Enter a comment..."} onChange={handleCommentChange} value={comment} fullWidth />
                        <Box>
                            <Button variant="contained" size={"small"} color={"primary"} onClick={handleClickAddComment}>Comment</Button>
                        </Box>
                        <Box>
                            <Button variant="contained" size={"small"} color={"primary"} onClick={close}>Cancel</Button>
                        </Box>
                    </Box>
                </CardActions>
            </Card>
        </Box>
    </Popover >
}

const mapStateToProps = (store: never) => ({
    project: selectProject(store),
    userId: selectUserId(store),
    user: selectUser(store)
});

export default connect(mapStateToProps, {
})(AddCommentCard);
